import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import AddCargoToItineraryCorrelativeForm from './CargoOperationCorrelativeForm';
import AddCargoToItineraryByQrButtonForm from './CargoOperationByQrButtonForm';

export const CargoOperationByQrModalForms = ({
  onClickAddItemToItinerary,
  setShowModal,
  cargoOperation,
  onClickClose,
  totalItems,
  itineraryId,
  locationId,
}) => {
  const [items, setItems] = useState([]);
  return (
    <>
      <AddCargoToItineraryCorrelativeForm
        items={items}
        setItems={setItems}
        cargoOperation={cargoOperation}
        itineraryId={itineraryId}
        locationId={locationId}
      />
      <AddCargoToItineraryByQrButtonForm
        items={items}
        onClickAddItemToItinerary={onClickAddItemToItinerary}
        setShowModal={setShowModal}
        cargoOperation={cargoOperation}
        onClickClose={onClickClose}
        totalItems={totalItems}
      />
    </>
  );
};

CargoOperationByQrModalForms.propTypes = {
  onClickAddItemToItinerary: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  cargoOperation: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  onClickClose: PropTypes.func.isRequired,
  totalItems: PropTypes.instanceOf(Immutable.List),
  itineraryId: PropTypes.number.isRequired,
  locationId: PropTypes.number.isRequired,
};

CargoOperationByQrModalForms.defaultProps = {
  totalItems: Immutable.List(),
};

export default CargoOperationByQrModalForms;
